import script from "./CarregandoCatalogo.vue?vue&type=script&setup=true&lang=js"
export * from "./CarregandoCatalogo.vue?vue&type=script&setup=true&lang=js"

import "./CarregandoCatalogo.vue?vue&type=style&index=0&id=0d2dc9be&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d2dc9be"]])

export default __exports__